import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'cc-input-errors',
  templateUrl: './input-errors.component.html',
  styleUrls: ['./input-errors.component.scss']
})
export class InputErrorsComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() inputName: string;
  @Input() inputIndex: string;
  @Input() errors: Array<any>;
  @Input() text: any;

  public error: any;

  constructor() {}

  ngOnInit(): void {
    const parsedIndex = parseInt(this.inputIndex, 10);
    this.getFirstError(parsedIndex);
    if (parsedIndex >= 0) {
      this.form.get([this.inputName, parsedIndex]).statusChanges.subscribe(() => this.getFirstError(parsedIndex));
    } else if (this.inputName) {
      this.form.get(this.inputName).statusChanges.subscribe(() => this.getFirstError('default'));
    }
  }

  getFirstError(parsedIndex) {
    this.errors.reverse().forEach((el, index) => {
      const key = Object.keys(el)[0];
      if (parsedIndex !== 'default' && parsedIndex >= 0) {
        if (this.form.get([this.inputName, parsedIndex]).hasError(key)) {
          this.error = { error: key, text: this.errors[index][key] };
        }
      } else if (this.form.get(this.inputName).hasError(key)) {
        this.error = { error: key, text: this.errors[index][key] };
      }
    });
  }
}
